import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { AppSettings } from '../enums/app-settings.enum';
import { AlertService } from '../services/alert.service';
import { LanguageSwitchService } from '../services/language-switch.service';
import { ApplicationInitializationService } from '../services/application-initialization.service';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  ANURL: string;
  private ENV: any;
  constructor(
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private ALS: AlertService,
    private toastController: ToastController,
    private appInitService: ApplicationInitializationService,
  ) { }

  private AHURL: string = `en${AppSettings.APPLICATION_HEADER_URL}`;
  private AFURL: string = `en${AppSettings.APPLICATION_FOOTER_URL}`;

  setAHURL(U: string): void {
    this.AHURL = U;
  }

  getAHURL() {
    return this.AHURL;
  }

  setAFURL(U: string): void {
    this.AFURL = U;
  }
  setANURL(U: string): void {
    this.ANURL = U;
  }

  getAFURL() {
    return this.AFURL;
  }

  getANURL() {
    return this.ANURL;
  }

  public getSelectedLanguage() {
    return new Promise((resolve, reject) => {
      this.route.queryParamMap.subscribe((params) => {
        const token: any = { ...params };
        const lang = token.params.locale
          ? token.params.locale.toLowerCase()
          : undefined;
        if (lang === 'ar') {
          this.LSS.setLanguage('ar');
          this.setAHURL(`ar${AppSettings.APPLICATION_HEADER_URL}`);
          this.setAFURL(`ar${AppSettings.APPLICATION_FOOTER_URL}`);
          this.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
          const urls = {
            APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
            APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
            APPLICATION_NAVIATION_URL:
              'ar' + AppSettings.APPLICATION_NAVIATION_URL,
          };
          resolve(urls);
        } else {
          this.LSS.setLanguage('en');
          this.setAHURL(`en${AppSettings.APPLICATION_HEADER_URL}`);
          this.setAFURL(`en${AppSettings.APPLICATION_FOOTER_URL}`);
          this.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
          const urls = {
            APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
            APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
            APPLICATION_NAVIATION_URL:
              'en' + AppSettings.APPLICATION_NAVIATION_URL,
          };
          resolve(urls);
        }
      });
    });
  }
  getLocaleLanguage(): string {
    const language = this.LSS.getLanguage();
    if (language) return language;
    else {
      if (localStorage.getItem('language')) {
        return localStorage.getItem('language');
      }
    }
    return 'en';
  }

  log(D: any) {
    // console.log(D);
  }
  error(E: any) {
    this.ALS.error(E);
    this.toast(E);
  }
  clearError() {
    this.ALS.clearAll();
  }

  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  createCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = ';expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires;
    return '';
  }
  async toast(M: string) {
    const toast = await this.toastController.create({
      message: `${M}`,
      duration: 2000,
    });
    toast.present();
  }
  async ValidationErrorToast(M: string) {
    const toast = await this.toastController.create({
      message: `${M}`,
      duration: 5000,
      position: 'top',
      color: 'dark'
    });
    toast.present();
  }
  getHeaders() {
    const req = new XMLHttpRequest();
    req.open('GET', window.location.href, false);
    req.send(null);
    const headers = req.getAllResponseHeaders().toLowerCase();
  }

  uniqByKeepLast(a, key) {
    return [...new Map(a.map((x) => [key(x), x])).values()];
  }
  uniqByKeepFirst(a, key) {
    let seen = new Set();
    return a.filter((item) => {
      let k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  }
  getBrowserInfo = function () {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }
    return browserName;
  };

  setENV(e) {
    localStorage.setItem('ENV', e);
  }

  getENV() {
    const e = localStorage.getItem('ENV');
    if (e) {
      if (e == 'mobile') {
        return e;
      } else {
        return 'web';
      }
    } else {
      return 'web';
    }
  }

  setAccessToken(e) {
    localStorage.setItem('AccessToken', e);
  }

  getAccessToken() {
    const e = localStorage.getItem('AccessToken');
    if (e) {
      return e;
    }
    return null;
  }


  setJSessionID(e) {
    localStorage.setItem('JSESSIONID', e);
    document.cookie = 'JSESSIONID=' + e;
  }
  setBigIpServer(e) {
    sessionStorage.setItem('BIGipServerb2cprod_443_pool', e);
    document.cookie = 'BIGipServerb2cprod_443_pool=' + e;
  }

  getJSessionID() {
    const e = localStorage.getItem('JSESSIONID');
    if (e) {
      return e;
    }
    return null;
  }

  getBigIpServer() {
    const e = sessionStorage.getItem('BIGipServerb2cprod_443_pool');
    if (e) {
      return e;
    }
    return null;
  }
  
  setMagentoCartId(e) {
    localStorage.setItem('magentoCartId', e);
  }

  getMagentoCartId() {
    const e = localStorage.getItem('magentoCartId');
    if (e) {
      return e;
    }
    return null;
  }

    setWSO2AccessToken(e) {
      localStorage.setItem('wso2AccessToken', e);
    }
  
    getWSO2AccessToken() {
        const e = localStorage.getItem('wso2AccessToken');
        if (e) {
          return e;
        }
        return null;
      }
      setIndividualLoginAccountNo(e) {
        localStorage.setItem('individualLoginAccountNo', e);
      }
    
      getIndividualLoginAccountNo() {
          const e = localStorage.getItem('individualLoginAccountNo');
          if (e) {
            return e;
          }
          return null;
        }
  isMobileDevice() {
    return /Mobi/i.test(window.navigator.userAgent);
  }

  getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = (/android/i.test(userAgent)) ? true : false;
    if (isAndroid) {
      return 'Android';
    }
    return 'iOS';
  }

 public convertIncommingDateToSysReadableDate(D: string) {
    if (D) {
      const dateParts = D.split(/[\s/:]+/); // Split the string into date and time parts
      // Parse the date parts
      const month = (dateParts[1]) ? parseInt(dateParts[0]) : null; // Months are zero-indexed
      const day = (dateParts[0]) ? parseInt(dateParts[1]) : null;
      const year = (dateParts[2]) ? parseInt(dateParts[2]) : null;
      const hour = (dateParts[3]) ? parseInt(dateParts[3]) : null;
      const minute = (dateParts[4]) ? parseInt(dateParts[4]) : null;
      const second = (dateParts[5]) ? parseInt(dateParts[5]) : null;

      // Create a new Date object with the adjusted timezone offset
      const date = new Date(year, month, day, hour, minute, second);
      date.setHours(date.getHours() - date.getTimezoneOffset() / 60);

      return date;
    }
    return new Date();
  }

  setSubscription(e) {
    localStorage.setItem('Subscription', e);
  }

  getSubscription() {
    const e = localStorage.getItem('Subscription');
    if (e) {
      return e;
    }
    return null;
  }
  setNavigationSourceFromApp(source){
    localStorage.setItem('source', source);
  }
  getNavigationSource(){
    return localStorage.getItem('source') || null
  }
  searchValidationErrorCode(key: string) {
    const errorCodesList = this.appInitService?.environmentConfig?.ERROR_CODES || [];
    const resultErrorCode = errorCodesList.find((errObj: any) => errObj?.errorCode === key);
    if(resultErrorCode){
      return resultErrorCode
    }else{
      return false;
    }
   
  }
  convertUnicodeToArabic(unicodeString: string): string {
    if (unicodeString) {
      return unicodeString.replace(/\\u([\d\w]{4})/gi, (match, grp) => {
        return String.fromCharCode(parseInt(grp, 16));
      });
    }
    return unicodeString;
  }

  changeDateFormat(inputDate: string) {
    let date;
    if (inputDate) {
      date = formatDate(inputDate, 'dd/MM/yyyy HH:mm:ss', 'en-US');
    }
    return date;
  }

  getSeletedSegmentName(id): String{
    if (id == AppSettings?.POSTPAID) return 'Postpaid';
    else if (id == AppSettings?.PREPAID) return 'Prepaid';
    else if (id == AppSettings?.CONTROL_LINE) return 'Controlline';
    else if (id == AppSettings?.VISITOR_LINE)return 'Visitorline';
    else if (id == AppSettings?.E_LIFE) return 'Elife';
    else if (id == AppSettings?.TV) return 'Tv';
    else if (id == AppSettings?.CALLS) return 'Calls';
    else return 'Postpaid';
  }

  
  format(phoneNumber: any) {
    return phoneNumber
      .replace(/\s+/g, '')
      .replace(/^(.{3})(.{3})(.*)$/, '$1 $2 $3');
  }

  getUniqueListBy(arr, key) {
    return  arr.filter((value, index, self) =>  index === self.findIndex((t) => (
      t[key] === value[key]
    ))
  )
}
 

  isScreenResponsive() {
    const w = document.documentElement.clientWidth || window.innerWidth;
    return w && w < 992 ? true : false;
  }

  checkNumberStartsWithZero(N) {
    let NS = N?.toString();
    if (NS && NS[0] !== '0') NS = '0' + NS;
    return NS;
  }


  parsePrice(v) {
    if (Number(v)) {
      return Number(v);
    }
    return v;
  }
capitalizeFirstLetter(S) {
  return S.charAt(0).toUpperCase() + S.slice(1).toLowerCase();
}
restrictString(str) {
  return str?.length > 53 ? str.slice(0, 53) : str;
}

formatAmount(amount) {
    return parseFloat(amount?.toFixed(2));
  }
   // Function to convert Unicode representation back to simple text
   fromUnicode(input) {
    return input?.split('\\u')?.filter(Boolean)?.map(function (hexCode) {
      return String.fromCharCode(parseInt(hexCode, 16));
    }).join('');
  }
  setNewAddonCard(e) {
    localStorage.setItem('newAddonCard', e);
  }

  getNewAddonCard() {
    const e = localStorage.getItem('newAddonCard');
    if (e) {
      return e;
    }
    return null;
  }
  

  setCategoryDimension(e) {
    localStorage.setItem('categoryDimension', e);
  }

  getCategoryDimension() {
    const e = localStorage.getItem('categoryDimension');
    if (e) {
      return e;
    }
    return null;
  }
  
}
